// @flow weak

// import _ from 'lodash/fp';
import React from 'react';
import {connect} from 'react-redux';
import {BrowserRouter, NavLink, Route, Redirect, Switch} from 'react-router-dom';
import PurchaseOrderReportContainer from '../PurchaseOrderReportContainer/PurchaseOrderReportContainer';
import SiteManagerReportContainer from '../SiteManagerReportContainer/SiteManagerReportContainer';
import AdminNavbar from '../../components/AdminNavbar/AdminNavbar';
import {logout} from '../../actions/auth';
import OrdersContainer from '../OrdersContainer/OrdersContainer';
import './SiteManagerContainer.css';

export type Props = {
  location: { pathname: string },
  onLogoutClick: Function,
};

const SiteManagerContainer = ({location: {pathname = ''} = {}, onLogoutClick}: Props) => (
  <BrowserRouter>
    <div className="SiteManagerContainer">
      <AdminNavbar onLogoutClick={onLogoutClick} />
      <div className="row content">
        <div className="shrink column">
          <div className="Sidebar">
            <div className="Sidebar-content">
              <div className="SiteManagerMenu">
                <NavLink
                  to={`${pathname}/sitemanagerreport`}
                  className="SiteManagerMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Platschefsrapport
                  </div>
                </NavLink>

                <NavLink
                  to={`${pathname}/purchasereport`}
                  className="SiteManagerMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Inköpsrapport
                  </div>
                </NavLink>

                <NavLink
                  to={`${pathname}/orders`}
                  className="SiteManagerMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Beställningar
                  </div>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className="small-12 large-expand column flex">
          <Switch>
            <Route
              path={`${pathname}/orders`}
              exact={true}
              component={() => <OrdersContainer readonly={true} />} />
            <Route
              path={`${pathname}/purchasereport`}
              exact={true}
              component={PurchaseOrderReportContainer} />
            <Route
              path={`${pathname}/sitemanagerreport`}
              exact={true}
              component={SiteManagerReportContainer} />
            <Route render={() => (<Redirect to={`${pathname}/sitemanagerreport`} />)} />
          </Switch>
        </div>
      </div>
    </div>
  </BrowserRouter>
);

const mapDispatchToProps = dispatch => ({
  onLogoutClick: () =>
    dispatch(logout()),
});

export default connect(
  () => ({}),
  mapDispatchToProps
)(SiteManagerContainer);



// WEBPACK FOOTER //
// ./src/containers/SiteManagerContainer/SiteManagerContainer.js